import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const PaperIcon = (props: Props) => {
    const { color = 'white', width = 36, height = 36, ...rest } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;
    return (
        <svg width={scaleWidthPixel(numericWidth)} height={scaleHeightPixel(numericHeight)} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path fillRule="evenodd" clipRule="evenodd" d="M9 8H27.4615V28H9V8ZM25.9231 9.5625V26.4375H10.5385V9.5625H25.9231Z" fill={color} />
            <rect x="13" y="14.5" width="10" height="1" fill={color} />
            <rect x="13" y="17.5" width="10" height="1" fill={color} />
            <rect x="13" y="20.5" width="10" height="1" fill={color} />
        </svg>
    );
};
